module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/client-send-invitation/client-send-invitation.component.scss
// module id = ./src/app/client-send-invitation/client-send-invitation.component.scss
// module chunks = main